import { downloadByUrl } from './file';

export const selectThesisItems = [
  {
    id: 'thesis',
    value: 'thesis',
    label: 'doctor.thesis.yes',
  },
  {
    id: 'nothesis',
    value: 'nothesis',
    label: 'doctor.thesis.no',
  },
];

export const thesisIds = ['thesis', 'nothesis'] as const;
export type ThesisId = (typeof thesisIds)[number];

export const selectInstallableItems = [
  {
    id: 'installable',
    value: 'installable',
    label: 'doctor.installable.yes',
  },
  {
    id: 'notinstallable',
    value: 'notinstallable',
    label: 'doctor.installable.no',
  },
];

export const installableIds = ['installable', 'notinstallable'] as const;
export type InstallableId = (typeof installableIds)[number];

export const downloadDoctorSubstituteContractByUrl = ({
  url,
  officeName,
  doctorAttending,
  from,
  to,
  signed,
}: {
  url: string;
  officeName: string;
  doctorAttending: string;
  from: string;
  to: string;
  signed: boolean;
}) => {
  const doctorAttendingStr = doctorAttending.split(' ').join('_');

  let filename: string;
  if (signed) {
    filename = `${officeName}_${doctorAttendingStr}_${from}_${to}_signé`;
  } else {
    filename = `${officeName}_${doctorAttendingStr}_${from}_${to}`;
  }

  return downloadByUrl({
    url,
    filename: filename.toLocaleLowerCase(),
  });
};
